import quadraImg from "static/quadra.png";
import calvertImg from "static/calvert.png";
import johnstoneImg from "static/js.png";
import ghImg from "static/gh.png";
import estuaryImg from "static/estuary.png";
import seaforthImg from "static/seaforth.png";
import clayoquotImg from "static/clayoquot.png";
import skeenaImg from "static/skeena.png";
import lowerMainlandImg from "static/lower_mainland.png";
import ncImg from "static/nc_territory.png";

// Every workarea the portal knows about. To add one, drop its map image in
// src/static and append a single entry here.
//
// name  - must match the string the API returns in user.workareas, which is
//         what gates visibility on the workarea picker.
// label - what the picker button displays.
// img   - map image shown on the picker button.
// soloSupported - set to false for workareas where Solo uploads are not
//         offered (see util/solo.js). Workareas default to supported.
const workareas = [
  {
    name: "CALVERT",
    label: "Calvert",
    img: calvertImg
  },
  {
    name: "JOHNSTONE STRAIT",
    label: "Johnstone Strait",
    img: johnstoneImg
  },
  {
    name: "QUADRA",
    label: "Quadra",
    img: quadraImg
  },
  {
    name: "GWAII HAANAS",
    label: "Gwaii Haanas",
    img: ghImg,
    soloSupported: false
  },
  {
    name: "ESTUARY",
    label: "Estuary",
    img: estuaryImg,
    soloSupported: false
  },
  {
    name: "SEAFORTH",
    label: "Seaforth",
    img: seaforthImg,
    soloSupported: false
  },
  {
    name: "CLAYOQUOT",
    label: "Clayoquot",
    img: clayoquotImg,
    soloSupported: false
  },
  {
    name: "SKEENA",
    label: "SKEENA",
    img: skeenaImg,
    soloSupported: false
  },
  {
    name: "NORTH COAST LAKE",
    label: "North Coast Lake",
    img: skeenaImg,
    soloSupported: false
  },
  {
    name: "CENTRAL COAST LAKE",
    label: "Central Coast Lake",
    img: skeenaImg,
    soloSupported: false
  },
  {
    name: "LOWER MAINLAND",
    label: "Lower Mainland",
    img: lowerMainlandImg
  },
  {
    name: "50 WATERSHEDS",
    label: "50 Watersheds",
    img: ncImg
  }
];

export default workareas;
